// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CookieContainer = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  padding: 12px 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  font-size: 14px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  z-index: 999;
  max-width: 200px;
  max-height: 250px;

  @media (max-width: 768px) {
    bottom: 10px;
    left: 10px;
    right: 10px;
    max-width: 90%;
    padding: 10px;
    font-size: 13px;
  }
`;

const CookieText = styled.p`
  margin: 0;
  margin-right: 10px;
  flex: 1;
`;

const StyledLink = styled(Link)`
  color: #4da6ff;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    text-decoration: underline;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: -15px;
  right: -50px;
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    color: #ff6b6b;
  }


`;

const CookieBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieInfoClosed = localStorage.getItem('cookieInfoClosed');
    if (!cookieInfoClosed) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('cookieInfoClosed', 'true');
    setIsVisible(false);
  };

  const handleFooterClick = () => {
    sessionStorage.setItem('fromFooterClick', 'true');
  };

  if (!isVisible) return null;

  return (
    <CookieContainer>
      <CloseButton onClick={handleClose}>✖</CloseButton>
      <CookieText>
        {t('cookieBanner.text')}{' '}
        <StyledLink to="/privacy-policy" onClick={handleFooterClick}>
          {t('cookieBanner.learnMore')}
        </StyledLink>.
      </CookieText>
    </CookieContainer>
  );
};

export default CookieBanner;
